import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons';
import paths from 'routes/paths';

const SessionExpired = () => {
  return (
    <div className="min-vh-50 d-flex align-items-start justify-content-center  pt-5">
      <div className="text-center">
        <p className="text-muted fs-6 mb-4">
          Your <strong>session has expired</strong> due to inactivity.<br />
          Please log in again to continue.
        </p>

        <Button
          as={Link}
          to={paths.simpleLogin}
          variant="success"
          className="mt-3 w-100 btn-lg fw-semibold d-flex align-items-center justify-content-center"
          style={{
            padding: "0.5rem 1.2rem",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
          Log In Again
        </Button>
      </div>
    </div>
  );
};

export default SessionExpired;